const url = process.env.VUE_APP_API_URL + "ending/pagcor_reports/transactional"

export default {
  namespaced: true,

  state: {
    records: [],
    recordsLoading: false,
    exportPDFLoading: false,
  },
  mutations: {
    setRecords (state, val) {
      state.records = val
    },
    setRecordsLoading (state, val) {
      state.recordsLoading = val
    },
    setExportPDFLoading (state, val) {
      state.exportPDFLoading = val
    }
  },

  actions: {
    async getRecords({ commit, rootState }, data) {
      commit("setRecordsLoading", true)

      try {
        const response = await fetch(`${url}?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecords", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setRecordsLoading", false)
      }
    },

    async doExportPDF({ commit, rootState }, data) {
      commit("setExportPDFLoading", true)

      try {
        const response = await fetch(`${url}/download_pdf?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.blob()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setExportPDFLoading", false)
      }
    },

    async doDeleteExported({ rootState }, data) {
      fetch(`${url}/delete_pdf?${data}` , {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${rootState.userToken}`,
        }
      })
    }
  }
}